(function () {
  'use strict';

  var CHEVRON_SVG = '<svg width="10" height="6" viewBox="0 0 10 6" aria-hidden="true" focusable="false"><path d="M1 1L5 5L9 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg>';

  /* Same one-way expand pattern as the main banner (nv2-cookie-banner.js): "Skaityti daugiau"
     is a plain button that swaps in the rest of the sentence and removes itself -- it must
     NOT be a real link to the privacy policy. Only "Privatumo politikoje", inside the
     revealed full text, is a real link.

     Desktop (>=750px) shows the FULL paragraph immediately, no toggle at all -- there is
     plenty of horizontal room in the wider desktop dialog, so truncating it there just adds
     an unnecessary extra click. Only mobile's narrower card clamps it and needs the toggle. */
  var CUSTOM_SHORT = 'Mes naudojame slapukus, kad pagerintume jūsų patirtį, analizuotume srautą…';
  var CUSTOM_FULL_PREFIX = 'Mes naudojame slapukus, kad pagerintume jūsų patirtį, analizuotume srautą ir suasmenintume turinį. Kai kurie slapukai yra būtini, o kiti padeda mums suprasti, kaip sąveikaujate su mūsų svetaine. Sužinokite daugiau mūsų ';

  function buildFullText(introP) {
    introP.innerHTML = '';
    introP.appendChild(document.createTextNode(CUSTOM_FULL_PREFIX));
    var link = document.createElement('a');
    link.href = '/policies/privacy-policy';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.className = 'nv2-pc-prefs-readmore';
    link.textContent = 'Privatumo politikoje';
    introP.appendChild(link);
    introP.appendChild(document.createTextNode('.'));
  }

  var restructured = false;
  function restructurePrefs(prefsRoot) {
    if (restructured) return;
    var dialog = prefsRoot.querySelector('#shopify-pc__prefs__dialog, .shopify-pc__prefs__dialog');
    if (!dialog) return;
    restructured = true;

    var actions = dialog.querySelector('.shopify-pc__prefs__header-actions');
    if (actions) dialog.appendChild(actions);

    var title = dialog.querySelector('#shopify-pc__prefs__header-title');
    if (title) title.textContent = 'Slapukų nustatymai';

    var introP = dialog.querySelector('.shopify-pc__prefs__intro-main p');
    if (introP) {
      if (window.innerWidth >= 750) {
        buildFullText(introP);
      } else {
        introP.innerHTML = '';
        introP.appendChild(document.createTextNode(CUSTOM_SHORT + ' '));

        var toggle = document.createElement('button');
        toggle.type = 'button';
        toggle.className = 'nv2-pc-prefs-readmore';
        toggle.textContent = 'Skaityti daugiau';
        toggle.addEventListener('click', function () {
          buildFullText(introP);
        });
        introP.appendChild(toggle);
      }
    }

    dialog.querySelectorAll('.shopify-pc__prefs__option').forEach(function (option) {
      var label = option.querySelector('label');
      if (!label) return;
      var titleNode = null;
      for (var i = 0; i < label.childNodes.length; i++) {
        var n = label.childNodes[i];
        if (n.nodeType === Node.TEXT_NODE && n.textContent.trim()) { titleNode = n; break; }
      }
      if (!titleNode) return;

      var left = document.createElement('span');
      left.className = 'nv2-pc-option-left';
      var titleSpan = document.createElement('span');
      titleSpan.className = 'nv2-pc-option-title';
      titleSpan.textContent = titleNode.textContent.trim();
      var chevron = document.createElement('span');
      chevron.className = 'nv2-pc-chevron';
      chevron.innerHTML = CHEVRON_SVG;
      left.appendChild(titleSpan);
      left.appendChild(chevron);

      label.replaceChild(left, titleNode);

      if (option.id === 'shopify-pc__prefs__essential') {
        var badge = document.createElement('span');
        badge.className = 'nv2-pc-always-on';
        badge.textContent = 'Visada aktyvus';
        label.appendChild(badge);
      }
    });
  }

  var existing = document.getElementById('shopify-pc__prefs');
  if (existing) {
    restructurePrefs(existing);
  } else {
    var observer = new MutationObserver(function () {
      var prefsRoot = document.getElementById('shopify-pc__prefs');
      if (prefsRoot) {
        restructurePrefs(prefsRoot);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
